var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oct-account-dialog',{staticClass:"ss-password-reset",attrs:{"title":"パスワードを変更しました"}},[_c('oct-form',{scopedSlots:_vm._u([{key:"primaryActions",fn:function(){return [_c('oct-button',{attrs:{"size":"large","block":""},nativeOn:{"click":function($event){return _vm.$router.push({name:'Login'})}}},[_vm._v(" ログインページへ ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }